var _style, _circle, _circle2, _circle3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _line, _rect7, _rect8, _rect9, _rect0, _polyline, _circle4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtLogin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: "100%",
    height: "100%",
    role: "img",
    "aria-label": "Animated work report illustration",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Work report") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .card      { fill: #ffffff; }\n    .card-edge { fill: none; stroke: rgba(16, 35, 59, 0.06); stroke-width: 1; }\n    .ruled     { fill: #d7e2ee; }\n    .ruled-2   { fill: #e6edf5; }\n    .axis      { stroke: #e6edf5; stroke-width: 2; stroke-linecap: round; }\n    .mark      { fill: #2b8fe0; }\n    .mark-alt  { fill: #19b87a; }\n\n    .bar {\n      transform-box: fill-box;\n      transform-origin: 50% 100%;\n      animation: grow 5s cubic-bezier(0.34, 1.2, 0.4, 1) infinite;\n    }\n    .bar-1 { animation-delay: 0s; }\n    .bar-2 { animation-delay: 0.13s; }\n    .bar-3 { animation-delay: 0.26s; }\n    .bar-4 { animation-delay: 0.39s; }\n\n    @keyframes grow {\n      0%, 4%   { transform: scaleY(0.04); }\n      20%, 74% { transform: scaleY(1); }\n      88%, 100%{ transform: scaleY(0.04); }\n    }\n\n    .trend {\n      fill: none;\n      stroke: #0f9d63;\n      stroke-width: 2.6;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n      stroke-dasharray: 132;\n      animation: draw 5s ease-in-out infinite;\n    }\n    @keyframes draw {\n      0%, 22%   { stroke-dashoffset: 132; }\n      52%, 74%  { stroke-dashoffset: 0; }\n      86%, 100% { stroke-dashoffset: 132; }\n    }\n\n    .tip {\n      transform-box: fill-box;\n      transform-origin: 50% 50%;\n      animation: tip 5s ease-in-out infinite;\n    }\n    @keyframes tip {\n      0%, 50%   { transform: scale(0); opacity: 0; }\n      58%, 76%  { transform: scale(1); opacity: 1; }\n      84%, 100% { transform: scale(0); opacity: 0; }\n    }\n\n    .badge {\n      transform-box: fill-box;\n      transform-origin: 50% 50%;\n      animation: pop 5s cubic-bezier(0.34, 1.45, 0.45, 1) infinite;\n    }\n    @keyframes pop {\n      0%, 56%   { transform: scale(0); opacity: 0; }\n      66%       { transform: scale(1.14); opacity: 1; }\n      72%, 80%  { transform: scale(1); opacity: 1; }\n      90%, 100% { transform: scale(0); opacity: 0; }\n    }\n\n    .tick {\n      stroke: #ffffff;\n      stroke-width: 3.2;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n      fill: none;\n      stroke-dasharray: 22;\n      animation: tick 5s ease-out infinite;\n    }\n    @keyframes tick {\n      0%, 62%   { stroke-dashoffset: 22; }\n      72%, 84%  { stroke-dashoffset: 0; }\n      88%, 100% { stroke-dashoffset: 22; }\n    }\n\n    .mote { animation: drift 6s ease-in-out infinite; }\n    .mote-2 { animation-duration: 7.5s; animation-delay: -2s; }\n    .mote-3 { animation-duration: 8.5s; animation-delay: -4s; }\n    @keyframes drift {\n      0%, 100% { transform: translateY(0); opacity: 0.55; }\n      50%      { transform: translateY(-7px); opacity: 1; }\n    }\n\n    @media (prefers-reduced-motion: reduce) {\n      .bar, .trend, .tip, .badge, .tick, .mote { animation: none; }\n      .bar   { transform: scaleY(1); }\n      .trend { stroke-dashoffset: 0; }\n      .tick  { stroke-dashoffset: 0; }\n      .tip, .badge { transform: scale(1); opacity: 1; }\n    }\n  ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "mote",
    cx: 24,
    cy: 58,
    r: 3.5,
    fill: "#ffffff",
    opacity: 0.55
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "mote mote-2",
    cx: 178,
    cy: 44,
    r: 4.5,
    fill: "#ffffff",
    opacity: 0.55
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "mote mote-3",
    cx: 170,
    cy: 176,
    r: 3,
    fill: "#ffffff",
    opacity: 0.55
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "card",
    x: 34,
    y: 34,
    width: 132,
    height: 128,
    rx: 16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "card-edge",
    x: 34.5,
    y: 34.5,
    width: 131,
    height: 127,
    rx: 15.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "ruled",
    x: 48,
    y: 50,
    width: 54,
    height: 7,
    rx: 3.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "ruled-2",
    x: 48,
    y: 63,
    width: 34,
    height: 6,
    rx: 3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 48,
    width: 18,
    height: 18,
    rx: 6,
    fill: "#eaf3fb"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 53,
    width: 8,
    height: 8,
    rx: 2.5,
    fill: "#2b8fe0"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "axis",
    x1: 48,
    y1: 140,
    x2: 152,
    y2: 140
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "bar bar-1 mark",
    x: 52,
    y: 112,
    width: 15,
    height: 27,
    rx: 4.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "bar bar-2 mark-alt",
    x: 76,
    y: 96,
    width: 15,
    height: 43,
    rx: 4.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "bar bar-3 mark",
    x: 100,
    y: 106,
    width: 15,
    height: 33,
    rx: 4.5
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "bar bar-4 mark-alt",
    x: 124,
    y: 82,
    width: 15,
    height: 57,
    rx: 4.5
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "trend",
    points: "59.5,106 83.5,90 107.5,100 131.5,76"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "tip",
    cx: 131.5,
    cy: 76,
    r: 4.5,
    fill: "#0f9d63"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "badge"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 150,
    r: 19,
    fill: "#0f9d63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 150,
    r: 19,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3,
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "tick",
    d: "M144.5 150.5 L150 156 L160 145"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtLogin);
export default __webpack_public_path__ + "static/media/art-login.99c46d79295d52c92e298f07e6395f13.svg";
export { ForwardRef as ReactComponent };